import styles from "./Cart.module.css";
import useAppState from "../../hooks/useAppState";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useCallback } from "react";
import { AppConfig } from "../../utils/config";
import { Helmet } from "react-helmet";

const stripePromise = loadStripe(AppConfig.stripeKeyProd);

export default function Cart() {
  const { shoppingCart } = useAppState();

  const cartItems = useCallback(() => {
    return shoppingCart.map((item) => item.ID);
  }, [shoppingCart]);

  const fetchClientSecret = useCallback(async () => {
    const response = await fetch(
      `${AppConfig.apiUrl}/create-checkout-session`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: cartItems(),
        }),
      }
    );
    const data = await response.json();
    return data.clientSecret;
  }, [cartItems]);

  const onShippingDetailsChange = async (shippingDetailsChangeEvent: {
    checkoutSessionId: string;
    shippingDetails: unknown;
  }) => {
    const { checkoutSessionId, shippingDetails } = shippingDetailsChangeEvent;
    const response = await fetch(`${AppConfig.apiUrl}/update-shipping`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        checkout_session_id: checkoutSessionId,
        shipping_details: shippingDetails,
      }),
    });
    const data = await response.json();

    if (data.type === "error") {
      return Promise.resolve({
        type: "reject",
        errorMessage: data.message,
      });
    } else {
      return Promise.resolve({ type: "accept" });
    }
  };

  const options = { fetchClientSecret, onShippingDetailsChange };

  return (
    <>
      <Helmet>
        <title>Shopping Cart | Martin Townsend Postal History</title>
        <meta
          name="description"
          content="Review your selected postal history items and complete your purchase. Secure checkout with worldwide shipping available."
        />
      </Helmet>
      <div className={styles.itemContainer}>
        {shoppingCart.length === 0 ? (
          <div className={styles.emptyCart}>
            <h2>Your cart is empty</h2>
            <p>Looking for something special?</p>
            <Link to="/">
              <Button variant="contained" disableElevation>
                Browse Items
              </Button>
            </Link>
          </div>
        ) : null}
        {shoppingCart.length > 0 && (
          <div className={styles.checkoutSection}>
            <div className={styles.embeddedCheckout}>
              <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={options}
              >
                <EmbeddedCheckout />
              </EmbeddedCheckoutProvider>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
